import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@services/translate/translate.service';

@Component({
    selector: 'title-selection',
    templateUrl: './title-selection.component.html',
    styleUrls: ['./title-selection.component.scss'],
    providers: [],
    standalone: false
})
export class TitleSelectionComponent {
  title: string;
  translations: any;
  titleTranslation: string;

  constructor(public dialogRef: MatDialogRef<TitleSelectionComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private ts: TranslateService) {
    this.translations = this.ts.get('general');
    this.titleTranslation = this.ts.get(this.data.titleTranslation);
  }
}
